import { render, staticRenderFns } from "./savechart.vue?vue&type=template&id=53a0323a&scoped=true&"
import script from "./savechart.vue?vue&type=script&lang=js&"
export * from "./savechart.vue?vue&type=script&lang=js&"
import style0 from "./savechart.vue?vue&type=style&index=0&id=53a0323a&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a0323a",
  null
  
)

export default component.exports